import { ShieldAlert, ShieldCheck } from 'lucide-react'
import { useState } from 'react'
import { useAdminBypass } from '~/app/admin-bypass'
import * as m from '~/paraglide/messages'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '~/shared/ui/alert-dialog'
import { Button } from '~/shared/ui/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '~/shared/ui/tooltip'

export function AdminBypassToggle() {
  const { isAdminViewing, isBypassing, enableBypass, disableBypass } = useAdminBypass()
  const [confirmOpen, setConfirmOpen] = useState(false)

  if (!isAdminViewing) return null

  const handleClick = () => {
    if (isBypassing) {
      disableBypass()
    } else {
      setConfirmOpen(true)
    }
  }

  const handleConfirm = () => {
    enableBypass()
    setConfirmOpen(false)
  }

  return (
    <>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              size="sm"
              variant={isBypassing ? 'default' : 'outline'}
              className={
                isBypassing
                  ? 'h-6 px-2 text-[10px] gap-1 bg-amber-600 hover:bg-amber-700 text-white'
                  : 'h-6 px-2 text-[10px] gap-1'
              }
              onClick={handleClick}
            >
              {isBypassing ? (
                <>
                  <ShieldCheck className="w-3 h-3" />
                  {m.adminBypassOn()}
                </>
              ) : (
                <>
                  <ShieldAlert className="w-3 h-3" />
                  {m.adminBypassLimits()}
                </>
              )}
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p className="mb-1 font-medium">{m.adminBypassIncludes()}</p>
            <ul className="space-y-0.5 text-xs">
              <li>• {m.unlimitedEvents()}</li>
              <li>• {m.unlimitedPlaces()}</li>
              <li>• {m.unlimitedPulseCredits()}</li>
            </ul>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      <AlertDialog open={confirmOpen} onOpenChange={setConfirmOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{m.adminBypassConfirmTitle()}</AlertDialogTitle>
            <AlertDialogDescription>{m.adminBypassConfirmDescription()}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>{m.cancel()}</AlertDialogCancel>
            <AlertDialogAction
              onClick={handleConfirm}
              className="bg-amber-600 hover:bg-amber-700 text-white"
            >
              {m.adminBypassEnable()}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}
